import axios, { AxiosResponse } from 'axios';

export const getSharedSnap = (token: string): Promise<AxiosResponse> =>
	axios.get(`/snaps/shared/${token}`);
